export default __webpack_public_path__ + "static/media/icons_audit.1cbae5c0.svg";